// import React, {
//   useCallback,
//   useEffect,
//   useMemo,
//   useRef,
//   useState,
// } from "react";
// import { DailogBox } from "../../../components/Elements/DailogBox/DailogBox";
// import CardsBorder from "../../../components/Cards/CardsBorder";
// import SelectList from "../../../components/common/SelectList";
// import { ReactComponent as CalenderIcon } from "../../../assets/svgs/Calendar.svg";
// import ThemedCalendar from "../../../components/Elements/CustomDatePicker/ThemedCalender";
// import { Button } from "antd";
// import { getApi, patchApi, postApi } from "../../../api/api_instance";
// import { API_URLS } from "../../../api/apiUrls";
// import dayjs from "dayjs";
// // import { toast } from "react-toastify";

// const ProjectSetUp = ({
//   open,
//   onCancel,
//   projectId,
//   projectData,
//   setProjectSetup,
//   setPopupData,
//   onSave,
// }) => {
//   const [page, setPage] = useState(1);
//   const [allForms, setAllForms] = useState([]);
//   const [approvalStatus, setApprovalStatus] = useState(null);
//   const [statusShow, setstatusShow] = useState(false);
//   const [hasMore, setHasMore] = useState(true);
//   const pageSize = 5;

//   console.log(projectData,"projectdatasssss")
//   const selectLicenseList = useMemo(
//     () => [
//       // { label: "SUB ADMIN", value: "sub-admin" },
//       // { label: "LOCATION", value: "location" },
//       { label: "SUB ADMIN", value: "location_admin" },
//       { label: "LOCATION", value: "location_user" },
//       { label: "EMPLOYEE", value: "employee" },
//       { label: "VENDOR", value: "vendor" },
//     ],
//     []
//   );
//   console.log(allForms,"allFormsallFormsallForms");
//   const yesNOList = useMemo(
//     () => [
//       { label: "YES", value: "yes" },
//       { label: "NO", value: "no" },
//     ],
//     []
//   );

//   const [selectedForms, setSelectedForms] = useState([]);
//   const [selectLicenseData, setSelectLicenseData] = useState({});
//   const [selectedDynamicFormAccess, setSelectedDynamicFormAccess] =
//     useState("no");
//   const [canCustomerAssignSection, setCanCustomerAssignSection] =
//     useState("no");
//   const [validTillDate, setValidTillDate] = useState("");
//   const [showCalendar, setShowCalendar] = useState(false);
//   const calendarRef = useRef(null);

//   const getStandardForms = async (pageNumber = 1, append = false) => {
//     try {
//       const response = await getApi({
//         apiUrl: API_URLS.GET_ACTIVE_STANDARDFORMS(
//           pageSize,
//           pageNumber,
//           { status: "Approved" },
//           "updatedAt"
//         ),
//       });

//       if (response.success) {
//         const filteredData = response.data.filter(
//           (item) => item.status === "Approved"
//         );

//         const formattedData = filteredData.map((item, index) => ({
//           formId: item._id,
//           serial: (pageNumber - 1) * pageSize + index + 1,
//           label: item.title,
//           value: item._id,
//           date: dayjs(item.updatedAt).format("YYYY/MM/DD"),
//         }));

//         const updatedForms = append
//           ? [...allForms, ...formattedData]
//           : formattedData;

//         setAllForms(updatedForms);

//         if (response.total <= response.skip + pageSize) {
//           setHasMore(false);
//         }
//       }
//     } catch (error) {
//       console.error("Error in fetching standard form data", error);
//     }
//   };

//   const handleDateChange = (date) => {
//     setValidTillDate(date);
//     setShowCalendar(false);
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (calendarRef.current && !calendarRef.current.contains(event.target)) {
//         setShowCalendar(false);
//       }
//     };

//     if (showCalendar) {
//       document.addEventListener("mousedown", handleClickOutside);
//     }

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [showCalendar]);

//   const handleSelectedFormChange = (value) => {
//     setSelectedForms((prev) =>
//       prev.includes(value)
//         ? prev.filter((item) => item !== value)
//         : [...prev, value]
//     );
//   };

//   const handleLicenseDataChange = (value, key) => {
//     setSelectLicenseData((prev) => ({
//       ...prev,
//       [key]: value,
//     }));
//   };
//   const approveProjectSetup = async (status) => {
//     try {
//       const response = await patchApi({
//         apiUrl: `/api/admin/project/approve-project-setup/${projectId}`,
//         data: {
//           status: status === 'approve' ? 'accept' : 'reject',
//           approvedBy: "6847f0d0a4bbfbf5b76faddb" // You may want to get this dynamically from user context
//         },
//       });

//       if (response.success) {
//         setPopupData({
//           type: "success",
//           title: status === 'approve' ? "Project Approved" : "Project Rejected",
//           message: `Project Setup ${status === 'approve' ? 'Approved' : 'Rejected'} Successfully`,
//         });

//         onCancel();
//         if (status === 'approve') {
//           setProjectSetup(true);
//         }
//       } else {
//         setPopupData({
//           type: "warning",
//           title: `Failed to ${status} Project`,
//           message: `${response.message}`,
//         });
//       }
//     } catch (error) {
//       console.error(`Error in ${status}ing project setup`, error);
//       setPopupData({
//         type: "error",
//         title: `${status === 'approve' ? 'Approval' : 'Rejection'} Failed`,
//         message: error.message || `Failed to ${status} Project Setup`,
//       });
//     } finally {
//       setTimeout(() => {
//         setPopupData(null);
//       }, 2000);
//     }
//   };

//   console.log(statusShow, "statusShowstatusShowstatusShow")

//   const createProjectSetUp = async (projectId, formData) => {
//     try {
//       const response = await postApi({
//         apiUrl: API_URLS.CREATE_PROJECT_SETUP(projectId),
//         data: formData,
//       });

//       if (response.success) {
//         // console.log(response.data.approval.status,"responsedataaaaaaaaaaaaaaaaaaaaaa")
//         setApprovalStatus(response.data.approval.status);
//         setstatusShow(projectData.approval.status_show === true || projectData.approval.status_show === "true");

//         setPopupData({
//           type: "success",
//           title: "Setup Completed",
//           message: "Project Setup Successfully Completed",
//         });

//         // onSave();
//         onCancel();
//         setProjectSetup(true);
//       } else {
//         setPopupData({
//           type: "warning",
//           title: "Failed in Setting up Project",
//           message: `${response.message}`,
//         });
//       }
//     } catch (error) {
//       console.error("Error in creating new Section", error);
//       setPopupData({
//         type: "error",
//         title: "Creation Failed",
//         message: error.message || "Failed in Setting up Project",
//       });
//       onCancel();
//     } finally {
//       setTimeout(() => {
//         setPopupData(null);
//       }, 2000);
//     }
//   };

//   const handleSubmit = async () => {
//     const checkedForms = allForms
//       .filter((form) => selectedForms.includes(form.value))
//       .map((form) => ({
//         id: form.formId,
//         date: dayjs(form.date).format("YYYY-MM-DD"),
//       }));

//     const uncheckedForms = allForms
//       .filter((form) => !selectedForms.includes(form.value))
//       .map((form) => ({ id: form.formId }));

//     const license = {
//       ...(selectLicenseData["location_admin"] && {
//         location_admin: Number(selectLicenseData["location_admin"]),
//       }),
//       ...(selectLicenseData["location_user"] && {
//         location_user: Number(selectLicenseData["location_user"]),
//       }),
//       ...(selectLicenseData["employee"] && {
//         employee: Number(selectLicenseData["employee"]),
//       }),
//       ...(selectLicenseData["vendor"] && {
//         vendor: Number(selectLicenseData["vendor"]),
//       }),
//     };

//     const formData = {
//       standard_form: {
//         checked: checkedForms,
//         unchecked: uncheckedForms,
//       },

//       license,
//       dynamic_form_access: selectedDynamicFormAccess === "yes",
//       section_access: canCustomerAssignSection === "yes",
//       valid_till_end_date: validTillDate
//         ? dayjs(validTillDate).format("YYYY-MM-DD")
//         : null,
//     };
//     createProjectSetUp(projectId, formData);
//   };

//   useEffect(() => {
//     if (projectData.dynamic_form_access) {
//       setSelectedDynamicFormAccess(
//         projectData?.dynamic_form_access ? "yes" : "no"
//       );
//     }

//     if (projectData.section_access) {
//       setCanCustomerAssignSection(projectData?.section_access ? "yes" : "no");
//     }

//     if (projectData.endDate) {
//       setValidTillDate(dayjs(projectData.approval.data[0].valid_till_end_date).format("MM/DD/YYYY"));
//     }
// // valid_till_end_date
//     if (projectData.license) {
//       const licenseData = projectData.approval.data[0].license;
//       setSelectLicenseData({
//         location_user: licenseData.location_user,
//         location_admin: licenseData.location_admin,
//         employee: licenseData.employee,
//         vendor: licenseData.vendor,
//       });
//     }

//     if (projectData.standard_form) {
//       const checkedForms = projectData.approval.data[0].standard_form.checked.map((form) => form.id);
//       setSelectedForms(checkedForms);
//     }


//     if (projectData.approval && projectData.approval.status) {
//       setApprovalStatus(projectData.approval.status);
//     }

//   }, [projectData]);

//   const handleSeeMore = () => {
//     const nextPage = page + 1;
//     setPage(nextPage);
//     getStandardForms(nextPage, true);
//   };

//   useEffect(() => {
//     getStandardForms(1, false);
//   }, []);

//   useEffect(() => {
//     if (projectData.approval) {
//       setApprovalStatus(projectData.approval.status);
//       setstatusShow(projectData.approval.status_show); // <- ye exact boolean
//     }
//   }, [projectData]);

//   const handleApprove = () => {
//     approveProjectSetup('approve');
//   };

//   const handleReject = () => {
//     approveProjectSetup('reject');
//   };

//   return (
//     <DailogBox open={open} onCancel={onCancel} width={800}>
//       <div className="p-8">
//         <CardsBorder>
//           <div className="py-6">
//             <SelectList
//               list={allForms}
//               title="Select Form"
//               selecteditems={selectedForms}
//               onChange={handleSelectedFormChange}
//               selectionType="checkbox"
//             />
//           </div>
//           <div className="flex justify-center py-4">
//             {hasMore > 0 && (
//               <div
//                 className="text-center w-44 border border-2-solid border-blue-800 rounded-full px-6 py-2 text-blue-800 cursor-pointer"
//                 onClick={handleSeeMore}
//               >
//                 See More
//               </div>
//             )}
//           </div>
//           <div className="flex justify-center py-4">
//             {/* {hasMore > 0 && (
//               <div
//                 className="text-center w-44 border border-2-solid border-blue-800 rounded-full px-6 py-2 text-blue-800 cursor-pointer"
//                 onClick={handleSeeMore}
//               >
//                 See More
//               </div>
//             )} */}
//           </div>
//         </CardsBorder>

//         <div className="mt-6">
//           <CardsBorder>
//             <div className="py-6">
//               <SelectList
//                 list={selectLicenseList}
//                 title="License"
//                 selecteditems={selectLicenseData}
//                 onChange={handleLicenseDataChange}
//                 selectionType="number"
//               />
//             </div>
//           </CardsBorder>
//         </div>

//         <div className="mt-6">
//           <CardsBorder>
//             <div className="py-6">
//               <SelectList
//                 list={yesNOList}
//                 title="Use Dynamic Form in this Project"
//                 selecteditems={selectedDynamicFormAccess}
//                 onChange={setSelectedDynamicFormAccess}
//                 selectionType="radio"
//               />
//             </div>
//           </CardsBorder>
//         </div>

//         <div className="mt-6">
//           <CardsBorder>
//             <div className="py-6">
//               <SelectList
//                 list={yesNOList}
//                 title="Can Customer Assign Section of any form"
//                 selecteditems={canCustomerAssignSection}
//                 onChange={setCanCustomerAssignSection}
//                 selectionType="radio"
//               />
//             </div>
//           </CardsBorder>
//         </div>

//         <div className="mt-6 relative">
//           <CardsBorder>
//             <div className="py-6">
//               <div className="px-10">
//                 <h4 className="text-2xl font-semibold">Valid Till End Date</h4>
//                 <hr className="my-4" />
//               </div>
//               <div className="space-y-6">
//                 <div
//                   className="flex justify-between items-center border-b pb-4 cursor-pointer"
//                   onClick={() => setShowCalendar(true)}
//                 >
//                   <span className="text-sm mx-14 font-light">
//                     {validTillDate || "DD/MM/YYYY"}
//                   </span>
//                   <CalenderIcon className="mx-10" />
//                 </div>
//               </div>
//             </div>
//           </CardsBorder>

//           {showCalendar && (
//             <div
//               className="absolute top-16 left-1/2 transform -translate-x-1/2 z-50"
//               ref={calendarRef}
//             >
//               <ThemedCalendar
//                 value={validTillDate}
//                 onChange={handleDateChange}
//               />
//             </div>
//           )}
//         </div>



//         <div className="mt-6 relative">
//           <CardsBorder>
//             <div className="py-6">
//               {/* <div className="px-10">
//                 <h4 className="text-2xl font-semibold">Status</h4>

//               </div> */}
//               <div className="space-y-6">
//                 <div className="flex justify-between items-center  pb-2">
//                   {/* Left side label */}
//                   <span className="text-sm mx-14 font-light">Status</span>

//                   {/* Right side status value */}
//                   <span className="text-sm mx-14 font-medium">
//                     {approvalStatus === "not_setup"
//                       ? "Not Setup"
//                       : approvalStatus === "pending_for_approval" ? "Pending for Approval"
//                         : approvalStatus === "accept"
//                           ? "Approved"
//                           : approvalStatus === "reject"
//                             ? "Reject"
//                             : ""}
//                   </span>
//                 </div>
//               </div>
//             </div>
//           </CardsBorder>
//         </div>






//         <div className="text-center my-8 flex justify-center gap-4">
//           {/* Show Submit button only when statusShow is false */}
//           {!statusShow && (
//             <Button
//               type="primary"
//               style={{ background: "#06513D", borderRadius: "10px",text:"white"}}
//               className="text-sm py-5 px-6"
//               // disabled={approvalStatus === "accept"}
//               onClick={handleSubmit}
//             >
//               Submit For Approval
//             </Button>
//           )}

//           {/* Show Approve and Reject buttons only when statusShow is true */}
//           {statusShow && (
//             <>
//               <Button
//                 type="primary"
//                 style={{ background: "#06513D", borderRadius: "10px" }}
//                 className="text-sm py-5 px-6"
//                 onClick={handleApprove}
//               >
//                 Approve
//               </Button>
//               <Button
//                 type="primary"
//                 style={{ background: "#DC2626", borderRadius: "10px" }}
//                 className="text-sm py-5 px-6"
//                 onClick={handleReject}
//               >
//                 Reject
//               </Button>
//             </>
//           )}
//         </div>


//       </div>
//     </DailogBox>
//   );
// };

// export default ProjectSetUp;


// import React, {
//   useCallback,
//   useEffect,
//   useMemo,
//   useRef,
//   useState,
// } from "react";
// import { DailogBox } from "../../../components/Elements/DailogBox/DailogBox";
// import CardsBorder from "../../../components/Cards/CardsBorder";
// import SelectList from "../../../components/common/SelectList";
// import { ReactComponent as CalenderIcon } from "../../../assets/svgs/Calendar.svg";
// import ThemedCalendar from "../../../components/Elements/CustomDatePicker/ThemedCalender";
// import { Button } from "antd";
// import { getApi, patchApi, postApi } from "../../../api/api_instance";
// import { API_URLS } from "../../../api/apiUrls";
// import dayjs from "dayjs";
// // import { toast } from "react-toastify";

// const ProjectSetUp = ({
//   open,
//   onCancel,
//   projectId,
//   projectData,
//   setProjectSetup,
//   setPopupData,
//   onSave,
// }) => {
//   const [page, setPage] = useState(1);
//   const [allForms, setAllForms] = useState([]);
//   const [approvalStatus, setApprovalStatus] = useState(null);
//   const [statusShow, setstatusShow] = useState(false);
//   const [hasMore, setHasMore] = useState(true);
//   const [errors, setErrors] = useState({});
//   const pageSize = 5;

//   console.log(projectData,"projectdatasssss")
//   const selectLicenseList = useMemo(
//     () => [
//       { label: "SUB ADMIN", value: "location_admin" },
//       { label: "LOCATION", value: "location_user" },
//       { label: "EMPLOYEE", value: "employee" },
//       { label: "VENDOR", value: "vendor" },
//     ],
//     []
//   );

//   console.log(allForms,"allFormsallFormsallForms");

//   const yesNOList = useMemo(
//     () => [
//       { label: "YES", value: "yes" },
//       { label: "NO", value: "no" },
//     ],
//     []
//   );

//   const [selectedForms, setSelectedForms] = useState([]);
//   const [selectLicenseData, setSelectLicenseData] = useState({});
//   const [selectedDynamicFormAccess, setSelectedDynamicFormAccess] = useState("no");
//   const [canCustomerAssignSection, setCanCustomerAssignSection] = useState("no");
//   const [validTillDate, setValidTillDate] = useState("");
//   const [showCalendar, setShowCalendar] = useState(false);
//   const [isDirty, setIsDirty] = useState(false);

//   const calendarRef = useRef(null);

//   // Validation function
//   const validateForm = () => {
//     const newErrors = {};

//     // Validate at least one form is selected
//     if (selectedForms.length === 0) {
//       // newErrors.forms = "Please select at least one form";
//        setPopupData({
//           type: "error",
//           title: "Error",
//           message: "Please select at least one form",
//         });
//     }

//     // Validate valid till date
//     if (!validTillDate) {
//       //newErrors.validTillDate = "Please select a valid till date";
//       setPopupData({
//           type: "error",
//           title: "Error",
//           message: "Please select a valid till date",
//         });
//     }

//     // Validate license data - all fields should have values
//     const requiredLicenseFields = ["location_admin", "location_user", "employee", "vendor"];
//     const missingLicenseFields = requiredLicenseFields.filter(
//       field => !selectLicenseData[field] || 
//                selectLicenseData[field] === "" || 
//                selectLicenseData[field] === 0 ||
//                isNaN(Number(selectLicenseData[field]))
//     );

//     if (missingLicenseFields.length > 0) {
//       newErrors.license = `Please provide valid license numbers for: ${missingLicenseFields.map(field => {
//         const licenseItem = selectLicenseList.find(item => item.value === field);
//         return licenseItem ? licenseItem.label : field;
//       }).join(", ")}`;
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const getStandardForms = async (pageNumber = 1, append = false) => {
//     try {
//       const response = await getApi({
//         apiUrl: API_URLS.GET_ACTIVE_STANDARDFORMS(
//           pageSize,
//           pageNumber,
//           { status: "Approved" },
//           "updatedAt"
//         ),
//       });

//       if (response.success) {
//         const filteredData = response.data.filter(
//           (item) => item.status === "Approved"
//         );

//         const formattedData = filteredData.map((item, index) => ({
//           formId: item._id,
//           serial: (pageNumber - 1) * pageSize + index + 1,
//           label: item.title,
//           value: item._id,
//           date: dayjs(item.updatedAt).format("YYYY/MM/DD"),
//         }));

//         const updatedForms = append
//           ? [...allForms, ...formattedData]
//           : formattedData;

//         setAllForms(updatedForms);

//         if (response.total <= response.skip + pageSize) {
//           setHasMore(false);
//         }
//       }
//     } catch (error) {
//       console.error("Error in fetching standard form data", error);
//     }
//   };

//   const handleDateChange = (date) => {
//     setValidTillDate(date);
//     setShowCalendar(false);
//     setIsDirty(true);
//     // Clear date validation error when date is selected
//     if (errors.validTillDate) {
//       setErrors(prev => ({ ...prev, validTillDate: null }));
//     }
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (calendarRef.current && !calendarRef.current.contains(event.target)) {
//         setShowCalendar(false);
//       }
//     };

//     if (showCalendar) {
//       document.addEventListener("mousedown", handleClickOutside);
//     }

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [showCalendar]);

//   const handleSelectedFormChange = (value) => {
//     setSelectedForms((prev) =>
//       prev.includes(value)
//         ? prev.filter((item) => item !== value)
//         : [...prev, value]
//     );
//     setIsDirty(true);
//     // Clear form validation error when forms are selected
//     if (errors.forms) {
//       setErrors(prev => ({ ...prev, forms: null }));
//     }
//   };

//   const handleLicenseDataChange = (value, key) => {
//     setSelectLicenseData((prev) => ({
//       ...prev,
//       [key]: value,
//     }));
//     setIsDirty(true);
//     // Clear license validation error when license data is updated
//     if (errors.license) {
//       setErrors(prev => ({ ...prev, license: null }));
//     }
//   };

//   const approveProjectSetup = async (status) => {
//     try {
//       const response = await patchApi({
//         apiUrl: `/api/admin/project/approve-project-setup/${projectId}`,
//         data: {
//           status: status === 'approve' ? 'accept' : 'reject',
//           approvedBy: "6847f0d0a4bbfbf5b76faddb" // You may want to get this dynamically from user context
//         },
//       });

//       if (response.success) {
//         setPopupData({
//           type: "success",
//           title: status === 'approve' ? "Project Approved" : "Project Rejected",
//           message: `Project Setup ${status === 'approve' ? 'Approved' : 'Rejected'} Successfully`,
//         });

//         onCancel();
//         if (status === 'approve') {
//           setProjectSetup(true);
//         }
//       } else {
//         setPopupData({
//           type: "warning",
//           title: `Failed to ${status} Project`,
//           message: `${response.message}`,
//         });
//       }
//     } catch (error) {
//       console.error(`Error in ${status}ing project setup`, error);
//       setPopupData({
//         type: "error",
//         title: `${status === 'approve' ? 'Approval' : 'Rejection'} Failed`,
//         message: error.message || `Failed to ${status} Project Setup`,
//       });
//     } finally {
//       setTimeout(() => {
//         setPopupData(null);
//       }, 2000);
//     }
//   };

//   console.log(statusShow, "statusShowstatusShowstatusShow")

//   const createProjectSetUp = async (projectId, formData) => {
//     try {
//       const response = await postApi({
//         apiUrl: API_URLS.CREATE_PROJECT_SETUP(projectId),
//         data: formData,
//       });

//       if (response.success) {
//         setApprovalStatus(response.data.approval.status);
//         setstatusShow(projectData.approval.status_show === true || projectData.approval.status_show === "true");

//         setPopupData({
//           type: "success",
//           title: "Setup Completed",
//           message: "Project Setup Successfully Completed",
//         });

//         onCancel();
//         setProjectSetup(true);
//       } else {
//         setPopupData({
//           type: "warning",
//           title: "Failed in Setting up Project",
//           message: `${response.message}`,
//         });
//       }
//     } catch (error) {
//       console.error("Error in creating new Section", error);
//       setPopupData({
//         type: "error",
//         title: "Creation Failed",
//         message: error.message || "Failed in Setting up Project",
//       });
//       onCancel();
//     } finally {
//       setTimeout(() => {
//         setPopupData(null);
//       }, 2000);
//     }
//   };

//   const handleSubmit = async () => {
//     // Validate form before submission
//     if (!validateForm()) {
//       setPopupData({
//         type: "error",
//         title: "Validation Error",
//         message: "Please fill all required fields correctly",
//       });
//       setTimeout(() => {
//         setPopupData(null);
//       }, 3000);
//       return;
//     }

//     const checkedForms = allForms
//       .filter((form) => selectedForms.includes(form.value))
//       .map((form) => ({
//         id: form.formId,
//         date: dayjs(form.date).format("YYYY-MM-DD"),
//       }));

//     const uncheckedForms = allForms
//       .filter((form) => !selectedForms.includes(form.value))
//       .map((form) => ({ id: form.formId }));

//     const license = {
//       ...(selectLicenseData["location_admin"] && {
//         location_admin: Number(selectLicenseData["location_admin"]),
//       }),
//       ...(selectLicenseData["location_user"] && {
//         location_user: Number(selectLicenseData["location_user"]),
//       }),
//       ...(selectLicenseData["employee"] && {
//         employee: Number(selectLicenseData["employee"]),
//       }),
//       ...(selectLicenseData["vendor"] && {
//         vendor: Number(selectLicenseData["vendor"]),
//       }),
//     };

//     const formData = {
//       standard_form: {
//         checked: checkedForms,
//         unchecked: uncheckedForms,
//       },
//       license,
//       dynamic_form_access: selectedDynamicFormAccess === "yes",
//       section_access: canCustomerAssignSection === "yes",
//       valid_till_end_date: validTillDate
//         ? dayjs(validTillDate).format("YYYY-MM-DD")
//         : null,
//     };

//     createProjectSetUp(projectId, formData);
//   };

//   useEffect(() => {
//     // Check if projectData exists and has necessary properties
//     if (!projectData) return;

//     // Set dynamic form access
//     if (projectData.dynamic_form_access !== undefined) {
//       setSelectedDynamicFormAccess(
//         projectData.dynamic_form_access ? "yes" : "no"
//       );
//     }

//     // Set section access
//     if (projectData.section_access !== undefined) {
//       setCanCustomerAssignSection(projectData.section_access ? "yes" : "no");
//     }

//     // Set valid till date with safe property access
//     const validTillEndDate = projectData?.approval?.data?.[0]?.valid_till_end_date || 
//                              null;

//     if (validTillEndDate) {
//       setValidTillDate(dayjs(validTillEndDate).format("MM/DD/YYYY"));
//     } else {

//     }

//     // Set license data with safe property access
//     const licenseData = projectData?.approval?.data?.[0]?.license || 
//                         projectData?.license;

//     if (licenseData) {
//       setSelectLicenseData({
//         location_user: licenseData.location_user || "",
//         location_admin: licenseData.location_admin || "",
//         employee: licenseData.employee || "",
//         vendor: licenseData.vendor || "",
//       });
//     }

//     // Set selected forms with safe property access
//     const standardFormData = projectData?.approval?.data?.[0]?.standard_form || 
//                             projectData?.standard_form;

//     if (standardFormData?.checked) {
//       const checkedForms = standardFormData.checked.map((form) => form.id);
//       setSelectedForms(checkedForms);
//     } else if (Array.isArray(standardFormData)) {
//       // If standardFormData is directly an array of forms
//       const checkedForms = standardFormData.map((form) => form.id);
//       setSelectedForms(checkedForms);
//     }

//     // Set approval status
//     if (projectData?.approval?.status) {
//       setApprovalStatus(projectData.approval.status);
//     }

//   }, [projectData]);

//   const handleSeeMore = () => {
//     const nextPage = page + 1;
//     setPage(nextPage);
//     getStandardForms(nextPage, true);
//   };

//   useEffect(() => {
//     getStandardForms(1, false);
//   }, []);

//   useEffect(() => {
//     // Check if projectData exists and has approval data
//     if (projectData?.approval) {
//       setApprovalStatus(projectData.approval.status);
//       setstatusShow(projectData.approval.status_show);
//     }
//   }, [projectData]);

//   const handleApprove = () => {
//     approveProjectSetup('approve');
//   };

//   const handleReject = () => {
//     approveProjectSetup('reject');
//   };

//   return (
//     <DailogBox open={open} onCancel={onCancel} width={800}>
//       <div className="p-8">
//         <CardsBorder>
//           <div className="py-6">
//             <SelectList
//               list={allForms}
//               title="Select Form"
//               selecteditems={selectedForms}
//               onChange={handleSelectedFormChange}
//               selectionType="checkbox"
//             />
//             {errors.forms && (
//               <div className="text-red-500 text-sm mt-2 px-10">
//                 {errors.forms}
//               </div>
//             )}
//           </div>
//           <div className="flex justify-center py-4">
//             {hasMore && (
//               <div
//                 className="text-center w-44 border border-2-solid border-blue-800 rounded-full px-6 py-2 text-blue-800 cursor-pointer"
//                 onClick={handleSeeMore}
//               >
//                 See More
//               </div>
//             )}
//           </div>
//         </CardsBorder>

//         <div className="mt-6">
//           <CardsBorder>
//             <div className="py-6">
//               <SelectList
//                 list={selectLicenseList}
//                 title="License"
//                 selecteditems={selectLicenseData}
//                 onChange={handleLicenseDataChange}
//                 selectionType="number"
//               />
//               {errors.license && (
//                 <div className="text-red-500 text-sm mt-2 px-10">
//                   {errors.license}
//                 </div>
//               )}
//             </div>
//           </CardsBorder>
//         </div>

//         <div className="mt-6">
//           <CardsBorder>
//             <div className="py-6">
//               <SelectList
//                 list={yesNOList}
//                 title="Use Dynamic Form in this Project"
//                 selecteditems={selectedDynamicFormAccess}
//                 onChange={setSelectedDynamicFormAccess}
//                 selectionType="radio"
//               />
//             </div>
//           </CardsBorder>
//         </div>

//         <div className="mt-6">
//           <CardsBorder>
//             <div className="py-6">
//               <SelectList
//                 list={yesNOList}
//                 title="Can Customer Assign Section of any form"
//                 selecteditems={canCustomerAssignSection}
//                 onChange={setCanCustomerAssignSection}
//                 selectionType="radio"
//               />
//             </div>
//           </CardsBorder>
//         </div>

//         <div className="mt-6 relative">
//           <CardsBorder>
//             <div className="py-6">
//               <div className="px-10">
//                 <h4 className={`text-2xl font-semibold ${errors.validTillDate ? 'text-red-500' : ''}`}>
//                   Valid Till End Date *
//                 </h4>
//                 <hr className={`my-4 ${errors.validTillDate ? 'border-red-500' : ''}`} />
//               </div>
//               <div className="space-y-6">
//                 <div
//                   className={`flex justify-between items-center border-b pb-4 cursor-pointer transition-colors duration-200 ${
//                     errors.validTillDate 
//                       ? 'border-red-500 bg-red-50' 
//                       : 'border-gray-300 hover:border-blue-500 hover:bg-blue-50'
//                   }`}
//                   onClick={() => setShowCalendar(true)}
//                 >
//                   <span className={`text-sm mx-14 font-light ${
//                     errors.validTillDate 
//                       ? 'text-red-500' 
//                       : validTillDate 
//                         ? 'text-gray-900' 
//                         : 'text-gray-400'
//                   }`}>
//                     {validTillDate || "DD/MM/YYYY"}
//                   </span>
//                   <CalenderIcon className={`mx-10 ${errors.validTillDate ? 'text-red-500' : 'text-gray-600'}`} />
//                 </div>
//                 {errors.validTillDate && (
//                   <div className="text-red-500 text-sm px-10 flex items-center">
//                     <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
//                       <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
//                     </svg>
//                     {errors.validTillDate}
//                   </div>
//                 )}

//               </div>
//             </div>
//           </CardsBorder>

//           {showCalendar && (
//             <div
//               className="absolute top-16 left-1/2 transform -translate-x-1/2 z-50 shadow-lg"
//               ref={calendarRef}
//             >
//               <ThemedCalendar
//                 value={validTillDate}
//                 onChange={handleDateChange}
//               />
//             </div>
//           )}
//         </div>

//         <div className="mt-6 relative">
//           <CardsBorder>
//             <div className="py-6">
//               <div className="space-y-6">
//                 <div className="flex justify-between items-center pb-2">
//                   <span className="text-sm mx-14 font-light">Status</span>
//                   <span className="text-sm mx-14 font-medium">
//                     {approvalStatus === "not_setup"
//                       ? "Not Setup"
//                       : approvalStatus === "pending_for_approval" 
//                         ? "Pending for Approval"
//                         : approvalStatus === "accept"
//                           ? "Approved"
//                           : approvalStatus === "reject"
//                             ? "Reject"
//                             : ""}
//                   </span>
//                 </div>
//               </div>
//             </div>
//           </CardsBorder>
//         </div>

//         <div className="text-center my-8 flex justify-center gap-4">
//           {!statusShow && (
//             <Button
//               type="primary"
//               style={{ background: "#06513D", borderRadius: "10px" }}
//               className="text-sm py-5 px-6"
//               onClick={handleSubmit}
//               disabled={approvalStatus === "accept" && !isDirty}
//             >
//               Submit For Approval
//             </Button>
//           )}

//           {statusShow && (
//             <>
//               <Button
//                 type="primary"
//                 style={{ background: "#06513D", borderRadius: "10px" }}
//                 className="text-sm py-5 px-6"
//                 onClick={handleApprove}
//               >
//                 Approve
//               </Button>
//               <Button
//                 type="primary"
//                 style={{ background: "#DC2626", borderRadius: "10px" }}
//                 className="text-sm py-5 px-6"
//                 onClick={handleReject}
//               >
//                 Reject
//               </Button>
//             </>
//           )}
//         </div>
//       </div>
//     </DailogBox>
//   );
// };

// export default ProjectSetUp;



import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { DailogBox } from "../../../components/Elements/DailogBox/DailogBox";
import CardsBorder from "../../../components/Cards/CardsBorder";
import SelectList from "../../../components/common/SelectList";
import { ReactComponent as CalenderIcon } from "../../../assets/svgs/Calendar.svg";
import ThemedCalendar from "../../../components/Elements/CustomDatePicker/ThemedCalender";
import { Button } from "antd";
import { getApi, patchApi, postApi } from "../../../api/api_instance";
import { API_URLS } from "../../../api/apiUrls";
import dayjs from "dayjs";
import PopupCard from "../../../components/Cards/PopupCard/PopupCard";
// import { toast } from "react-toastify";

const ProjectSetUp = ({
  open,
  onCancel,
  projectId,
  projectData,
  setProjectSetup,
  setPopupData,
  onSave,
}) => {
  const [page, setPage] = useState(1);
  const [allForms, setAllForms] = useState([]);
  const [approvalStatus, setApprovalStatus] = useState(null);
  const [statusShow, setstatusShow] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [errors, setErrors] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupDatas] = useState({
    type: "success",
    title: "Success",
    message: "",
  });
  const pageSize = 5;
  const formDisabled = Boolean(statusShow);
  // console.log(projectData, "projectdatasssss")
  // working
  const selectLicenseList = useMemo(
    () => [
      // { label: "SUB ADMIN", value: "location_admin" },
      // { label: "SUB ADMIN", value: "sub_admin" },
      // { label: "LOCATION USER", value: "location_user" },
      { label: "USER", value: "user" },
      { label: "EMPLOYEE", value: "employee" },
      { label: "VENDOR", value: "vendor" },
      { label: "Local Superviser", value: "local_supervisor" },
    ],
    []
  );

  // console.log(allForms, "allFormsallFormsallForms");

  const yesNOList = useMemo(
    () => [
      { label: "YES", value: "yes" },
      { label: "NO", value: "no" },
    ],
    []
  );

  const [selectedForms, setSelectedForms] = useState([]);
  const [initialSelectedForms, setInitialSelectedForms] = useState([]);
  const [selectLicenseData, setSelectLicenseData] = useState({});
  const [selectedDynamicFormAccess, setSelectedDynamicFormAccess] = useState("no");
  const [canCustomerAssignSection, setCanCustomerAssignSection] = useState("no");
  const [validTillDate, setValidTillDate] = useState("");
  const [showCalendar, setShowCalendar] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [searchText, setSearchText] = useState("");

  const calendarRef = useRef(null);

  const displayForms = useMemo(() => {
    const searched = allForms.filter((form) =>
      form.label.toLowerCase().includes(searchText.toLowerCase())
    );
    return [...searched].sort((a, b) => {
      const aSelected = initialSelectedForms.includes(a.value);
      const bSelected = initialSelectedForms.includes(b.value);
      if (aSelected && !bSelected) return -1;
      if (!aSelected && bSelected) return 1;
      return 0;
    });
  }, [allForms, initialSelectedForms, searchText]);

  // Fixed validation function
  const triggerPopup = (type, title, message, duration = 3000) => {
    setPopupDatas({ type, title, message });
    setShowPopup(true);
    setTimeout(() => setShowPopup(false), duration);
  };

  // const validateForm = () => {
  //   const newErrors = {};
  //   const errorMessages = [];

  //   // Validate at least one form is selected
  //   if (selectedForms.length === 0) {
  //     // newErrors.forms = "Please select at least one form";
  //     // errorMessages.push("Please select at least one form");
  //     triggerPopup(
  //       "error",
  //       "Error",
  //       "Please select at least one form",
  //     );
  //   }

  //   // Validate valid till date
  //   if (!validTillDate) {
  //     // newErrors.validTillDate = "Please select a valid till date";
  //     // errorMessages.push("Please select a valid till date");
  //     triggerPopup(
  //       "error",
  //       "Error",
  //       "Please select a valid till date",
  //     );
  //   }

  //   if(selectLicenseData.length===0)
  //   {
  //     triggerPopup(
  //       "error",
  //       "Error",
  //       "Please select at least one lisence",
  //     );
  //   }
  //   // Validate license data - all fields should have values
  //   const requiredLicenseFields = ["location_admin", "location_user", "employee", "vendor"];
  //   const missingLicenseFields = requiredLicenseFields.filter(
  //     field => !selectLicenseData[field] ||
  //       selectLicenseData[field] === "" ||
  //       selectLicenseData[field] === 0 ||
  //       isNaN(Number(selectLicenseData[field]))
  //   );

  //   if (missingLicenseFields.length > 0) {
  //     const missingLabels = missingLicenseFields.map(field => {
  //       const licenseItem = selectLicenseList.find(item => item.value === field);
  //       return licenseItem ? licenseItem.label : field;
  //     }).join(", ");

  //     // newErrors.license = `Please provide valid license numbers for: ${missingLabels}`;
  //     // errorMessages.push(`Please provide valid license numbers for: ${missingLabels}`);
  //     triggerPopup(
  //       "error",
  //       "Error",
  //       "Please select at least one lisence",
  //     );
  //   }

  //   setErrors(newErrors);

  //   // Show popup with all validation errors
  //   if (errorMessages.length > 0) {
  //     setPopupData({
  //       type: "error",
  //       title: "Validation Error",
  //       message: errorMessages.join(". "),
  //     });

  //     // Auto-hide popup after 4 seconds
  //     setTimeout(() => {
  //       setPopupData(null);
  //     }, 4000);
  //   }

  //   return Object.keys(newErrors).length === 0;
  // };
  const validateForm = () => {
    // 1) Forms
    if (!Array.isArray(selectedForms) || selectedForms.length === 0) {
      triggerPopup("error", "Error", "Please select at least one form");
      return false;
    }

    // 2) Valid till date


    // 3) License validation
    const licenseObj = selectLicenseData || {};
    // const requiredLicenseFields = ["location_admin", "location_user", "employee", "vendor"];
const requiredLicenseFields = ["sub_admin", "user", "employee", "vendor"];
    // At least one license must be valid (> 0 and numeric)
    const hasAnyValidLicense = Object.values(licenseObj).some(
      (val) => val !== "" && val !== null && !isNaN(Number(val)) && Number(val) > 0
    );

    if (!hasAnyValidLicense) {
      triggerPopup("error", "Error", "Please select at least one license");
      return false;
    }

    if (!validTillDate) {
      triggerPopup("error", "Error", "Please select a valid till date");
      return false;
    }

    // If you want ALL licenses required, uncomment below:
    /*
    const missingLicenseFields = requiredLicenseFields.filter((field) => {
      const val = licenseObj[field];
      return !val || isNaN(Number(val)) || Number(val) <= 0;
    });
  
    if (missingLicenseFields.length > 0) {
      const missingLabels = missingLicenseFields
        .map((field) => {
          const item = selectLicenseList.find((i) => i.value === field);
          return item ? item.label : field;
        })
        .join(", ");
  
      triggerPopup("error", "Error", `Please provide valid license numbers for: ${missingLabels}`);
      return false;
    }
    */

    // ✅ Passed all checks
    return true;
  };

  const getStandardForms = async () => {
    try {
      const response = await getApi({
        apiUrl: API_URLS.GET_ACTIVE_STANDARDFORMS(
          1000,
          1,
          { status: "Approved" },
          "updatedAt"
        ),
      });

      let allottedForms = [];
      try {
        const allottedRes = await getApi({
          apiUrl: API_URLS.GET_STANDARD_FORM_BY_PROJECTID(projectId, "", 1, 100),
        });
        if (allottedRes.success && allottedRes.data && allottedRes.data.records) {
          allottedForms = allottedRes.data.records;
        }
      } catch (err) {
        console.error("Error fetching allotted forms", err);
      }

      if (response.success) {
        const filteredData = response.data.filter(
          (item) => item.status === "Approved"
        );

        const formattedActiveData = filteredData.map((item, index) => ({
          formId: item._id,
          serial: index + 1,
          label: item.title,
          value: item._id,
          date: dayjs(item.updatedAt).format("YYYY/MM/DD"),
        }));

        const formattedAllottedData = allottedForms.map((item) => ({
          formId: item._id,
          serial: 0,
          label: item.title,
          value: item._id,
          date: dayjs(item.updatedAt).format("YYYY/MM/DD"),
        }));

        let mergedForms = [...formattedActiveData];
        formattedAllottedData.forEach((allotted) => {
          if (!mergedForms.some((form) => form.value === allotted.value)) {
            mergedForms.push(allotted);
          }
        });

        setAllForms(mergedForms);
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error in fetching standard form data", error);
    }
  };

  // const handleDateChange = (date) => {
  //   if (formDisabled) return;
  //   setValidTillDate(date);
  //   setShowCalendar(false);
  //   setIsDirty(true);
  //   // Clear date validation error when date is selected
  //   if (errors.validTillDate) {
  //     setErrors(prev => ({ ...prev, validTillDate: null }));
  //   }
  // };
  const handleDateChange = (date) => {
    if (formDisabled) return;

    setValidTillDate(date);
    setShowCalendar(false);
    setIsDirty(true);
    // Clear date validation error when date is selected
    if (errors.validTillDate) {
      setErrors(prev => ({ ...prev, validTillDate: null }));
    }
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setShowCalendar(false);
      }
    };

    if (showCalendar) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showCalendar]);

  const handleSelectedFormChange = (value) => {
    if (formDisabled) return;
    setSelectedForms((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );
    setIsDirty(true);
    // Clear form validation error when forms are selected
    if (errors.forms) {
      setErrors(prev => ({ ...prev, forms: null }));
    }
  };

  const handleLicenseDataChange = (value, key) => {
    const values = projectData?.license?.[key] ?? null;
    
    // If we have license data, check if the change is valid based on current usage
    if (values) {
      let usedCount = values.total - values.unused;
      if (value < usedCount) {
        triggerPopup("error", "Error", "This customer has already used all allocated licenses. You cannot reduce the license count below the number of licenses currently in use");
        return;
      }
    }

    if (formDisabled) return;
    setSelectLicenseData((prev) => ({
      ...prev,
      [key]: value,
    }));
    setIsDirty(true);
    // Clear license validation error when license data is updated
    if (errors.license) {
      setErrors(prev => ({ ...prev, license: null }));
    }
  };

  const approveProjectSetup = async (status) => {
    try {
      const response = await patchApi({
        apiUrl: `/api/admin/project/approve-project-setup/${projectId}`,
        data: {
          status:  status === 'approve' ? 'accept' : 'reject',
          approvedBy: "69f09482d91affc46c33e0b2" // You may want to get this dynamically from user context
        },
      });

      if (response.success) {
        setPopupData({
          type: "success",
          title: status === 'approve' ? "Project Approved" : "Project Rejected",
          message: `Project Setup ${status === 'approve' ? 'Approved' : 'Rejected'} Successfully`,
        });

        onCancel();
        setProjectSetup(true);
        // if (status === 'approve') {
        // }
      } else {
        setPopupData({
          type: "warning",
          title: `Failed to ${status} Project`,
          message: `${response.message}`,
        });
      }
    } catch (error) {
      console.error(`Error in ${status}ing project setup`, error);
      setPopupData({
        type: "error",
        title: `${status === 'approve' ? 'Approval' : 'Rejection'} Failed`,
        message: error.message || `Failed to ${status} Project Setup`,
      });
    } finally {
      setTimeout(() => {
        setPopupData(null);
      }, 2000);
    }
  };

  console.log(statusShow, "statusShowstatusShowstatusShow")

  const createProjectSetUp = async (projectId, formData) => {
    try {
      const response = await postApi({
        apiUrl: API_URLS.CREATE_PROJECT_SETUP(projectId),
        data: formData,
      });

      if (response.success) {
        setApprovalStatus(response.data.approval.status);
        setstatusShow(projectData.approval.status_show === true || projectData.approval.status_show === "true");

        setPopupData({
          type: "success",
          title: "Setup Completed",
          message: "Your request has been sent for approval!",
        });

        onCancel();
        setProjectSetup(true);
      } else {
        setPopupData({
          type: "warning",
          title: "Failed in Setting up Project",
          message: `${response.message}`,
        });
      }
    } catch (error) {
      console.error("Error in creating new Section", error);
      setPopupData({
        type: "error",
        title: "Creation Failed",
        message: error.message || "Failed in Setting up Project",
      });
      onCancel();
    } finally {
      setTimeout(() => {
        setPopupData(null);
      }, 2000);
    }
  };

  const handleSubmit = async () => {
    // Validate form before submission
    if (!validateForm()) {
      // Validation failed, popup is already shown in validateForm()
      return;
    }

    const checkedForms = allForms
      .filter((form) => selectedForms.includes(form.value))
      .map((form) => ({
        id: form.formId,
        date: dayjs(form.date).format("YYYY-MM-DD"),
      }));

    const uncheckedForms = allForms
      .filter((form) => !selectedForms.includes(form.value))
      .map((form) => ({ id: form.formId }));

    const license = {
      // ...(selectLicenseData["location_admin"] && {
      //   location_admin: Number(selectLicenseData["location_admin"]),
      // }),
      // ...(selectLicenseData["location_user"] && {
      //   location_user: Number(selectLicenseData["location_user"]),
      // }),
      ...(selectLicenseData["sub_admin"] && {
        sub_admin: Number(selectLicenseData["sub_admin"]),
      }),
      ...(selectLicenseData["user"] && {
        user: Number(selectLicenseData["user"]),
      }),
      ...(selectLicenseData["employee"] && {
        employee: Number(selectLicenseData["employee"]),
      }),
      ...(selectLicenseData["vendor"] && {
        vendor: Number(selectLicenseData["vendor"]),
      }),
      ...(selectLicenseData["local_supervisor"] && {
        local_supervisor: Number(selectLicenseData["local_supervisor"]),
      }),
    };

    const formData = {
      standard_form: {
        checked: checkedForms,
        unchecked: uncheckedForms,
      },
      license,
      dynamic_form_access: selectedDynamicFormAccess === "no",
      section_access: canCustomerAssignSection === "no",
      valid_till_end_date: validTillDate
        ? dayjs(validTillDate).format("YYYY-MM-DD")
        : null,
    };

    createProjectSetUp(projectId, formData);
  };

  useEffect(() => {
    // Check if projectData exists and has necessary properties
    if (!projectData) return;

    // Set dynamic form access
    if (projectData.dynamic_form_access !== undefined) {
      setSelectedDynamicFormAccess(
        projectData.dynamic_form_access ? "yes" : "no"
      );
    }

    // Set section access
    if (projectData.section_access !== undefined) {
      setCanCustomerAssignSection(projectData.section_access ? "yes" : "no");
    }

    // Set valid till date with safe property access
    const validTillEndDate = projectData?.approval?.data?.[0]?.valid_till_end_date ||
      null;

    if (validTillEndDate) {
      setValidTillDate(dayjs(validTillEndDate).format("MM/DD/YYYY"));
    } else {

    }

    // Set license data with safe property access
    const licenseData = projectData?.approval?.data?.[0]?.license ||
      projectData?.license;

    if (licenseData) {
      setSelectLicenseData({
        // location_user: licenseData.location_user || "",
        // location_admin: licenseData.location_admin || "",
        user: licenseData.user || "",
        // sub_admin: licenseData.sub_admin || "",
        employee: licenseData.employee || "",
        vendor: licenseData.vendor || "",
        local_supervisor:licenseData.local_supervisor|| "",
      });
    }

    // Set selected forms with safe property access
    const standardFormData = projectData?.approval?.data?.[0]?.standard_form ||
      projectData?.standard_form;

    let checkedForms = [];
    if (standardFormData?.checked) {
      checkedForms = standardFormData.checked.map((form) => form.id);
    } else if (Array.isArray(standardFormData)) {
      // If standardFormData is directly an array of forms
      checkedForms = standardFormData.map((form) => form.id);
    }
    setSelectedForms(checkedForms);
    setInitialSelectedForms(checkedForms);

    // Set approval status
    if (projectData?.approval?.status) {
      setApprovalStatus(projectData.approval.status);
    }

  }, [projectData]);

  useEffect(() => {
    getStandardForms();
  }, []);

  useEffect(() => {
    // Check if projectData exists and has approval data
    if (projectData?.approval) {
      setApprovalStatus(projectData.approval.status);
      setstatusShow(projectData.approval.status_show);
    }
  }, [projectData]);

  const handleApprove = () => {
    approveProjectSetup('approve');
  };

  const handleReject = () => {
    approveProjectSetup('reject');
  };

  return (
    <DailogBox open={open} onCancel={onCancel} width={800}>
      <div className="p-8">
        <CardsBorder>
          <div className="py-6 px-10">
            <h4 className="text-2xl font-semibold mb-4">Select Form</h4>
            <div className="mb-4">
              <input
                type="text"
                placeholder="Search forms..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#06513D] text-sm"
              />
            </div>
            
            <div className="max-h-[300px] overflow-y-auto border border-gray-200 rounded-lg p-2 custom-scrollbar">
              <SelectList
                list={displayForms}
                title=""
                selecteditems={selectedForms}
                onChange={handleSelectedFormChange}
                selectionType="checkbox"
                paddingRequired={false}
                disabled={formDisabled}
              />
            </div>
            {errors.forms && (
              <div className="text-red-500 text-sm mt-2 px-10">
                {errors.forms}
              </div>
            )}
          </div>
        </CardsBorder>

        <div className="mt-6">
          <CardsBorder>
            <div className="py-6">
              <SelectList
                list={selectLicenseList}
                title="License"
                selecteditems={selectLicenseData}
                onChange={handleLicenseDataChange}
                selectionType="number"
                disabled={formDisabled}
              />
              {errors.license && (
                <div className="text-red-500 text-sm mt-2 px-10">
                  {errors.license}
                </div>
              )}
            </div>
          </CardsBorder>
        </div>

        {/* <div className="mt-6">
          <CardsBorder>
            <div className="py-6">
              <SelectList
                list={yesNOList}
                title="Use Dynamic Form in this Project"
                selecteditems={selectedDynamicFormAccess}
                // onChange={setSelectedDynamicFormAccess}
                  onChange={(v) => !formDisabled && setSelectedDynamicFormAccess(v)}
                // selectionType="radio"
                 selectionType="checkbox"
                disabled={formDisabled}
              />
            </div>
          </CardsBorder>
        </div> */}

        {/* <div className="mt-6">
          <CardsBorder>
            <div className="py-6">
              <SelectList
                list={yesNOList}
                title="Can Customer Assign Section of any form"
                selecteditems={canCustomerAssignSection}
                  //  onChange={setCanCustomerAssignSection}
                //   selectionType="radio"
                //  disabled={formDisabled}
                onChange={(v) => !formDisabled && setSelectedDynamicFormAccess(v)}
                 selectionType="checkbox"
                disabled={formDisabled}
              />
            </div>
          </CardsBorder>
        </div> */}

        <div className="mt-6 relative">
          <CardsBorder>
            <div className="py-6">
              <div className="px-10">
                <h4 className={`text-2xl font-semibold ${errors.validTillDate ? 'text-red-500' : ''}`}>
                  Valid Till End Date *
                </h4>
                <hr className={`my-4 ${errors.validTillDate ? 'border-red-500' : ''}`} />
              </div>
              <div className="space-y-6">
                <div
                  className={`flex justify-between items-center  pb-4 cursor-pointer transition-colors duration-200 ${errors.validTillDate
                    ? 'border-red-500 bg-red-50'
                    : 'border-gray-300 '
                    }`}
                  // onClick={() => setShowCalendar(true)}
                  onClick={() => !statusShow && setShowCalendar(true)}
                >
                  {/* working */}
                  <span className={`text-sm mx-14 font-light ${errors.validTillDate
                    ? 'text-red-500'
                    : validTillDate
                      ? 'text-gray-900'
                      : 'text-gray-400'
                    }`}>
                    {validTillDate ? dayjs(validTillDate).format("DD/MM/YYYY") : "DD/MM/YYYY"}
                  </span>
                  <CalenderIcon className={`mx-10 ${errors.validTillDate ? 'text-red-500' : 'text-gray-600'}`} />
                </div>
                {errors.validTillDate && (
                  <div className="text-red-500 text-sm px-10 flex items-center">
                    <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                    </svg>
                    {errors.validTillDate}
                  </div>
                )}

              </div>
            </div>
          </CardsBorder>

          {showCalendar && (
            <div
              className="absolute top-16 left-1/2 transform -translate-x-1/2 z-50 shadow-lg"
              ref={calendarRef}
            >
              {/* <ThemedCalendar
                value={validTillDate}
                onChange={handleDateChange}
                disabled={formDisabled}
              /> */}
              <ThemedCalendar
                value={validTillDate}
                onChange={handleDateChange}
                onClose={() => setShowCalendar(false)}  // ✅ Added onClose prop
                disabled={formDisabled}
              />
            </div>
          )}
        </div>

        <div className="mt-6 relative">
          <CardsBorder>
            <div className="py-6">
              <div className="space-y-6">
                <div className="flex justify-between items-center pb-2">
                  <span className="text-sm mx-14 font-light">Status</span>
                  <span className="text-sm mx-14 font-medium">
                    {approvalStatus === "not_setup"
                      ? "Not Setup"
                      : approvalStatus === "pending_for_approval"
                        ? "Pending for Approval"
                        : approvalStatus === "accept"
                          ? "Approved"
                          : approvalStatus === "reject"
                            ? "Reject"
                            : ""}
                  </span>
                </div>
              </div>
            </div>
          </CardsBorder>
        </div>

        <div className="text-center my-8 flex justify-center gap-4">
          {!statusShow && (
            <Button
              type="primary"
              style={{
                background: approvalStatus === "accept" && !isDirty ? "#A0A0A0" : "#06513D", // Disabled gray
                borderRadius: "10px",
                border: "none",
                opacity: approvalStatus === "accept" && !isDirty ? 0.6 : 1, // Slight fade
                cursor: approvalStatus === "accept" && !isDirty ? "not-allowed" : "pointer",
              }}
              className="text-sm py-5 px-6"
              onClick={handleSubmit}
              disabled={approvalStatus === "accept" && !isDirty}
            >
              Submit For Approval
            </Button>
          )}


          {statusShow && (
            <>
              <Button
                type="primary"
                style={{ background: "#06513D", borderRadius: "10px" }}
                className="text-sm py-5 px-6 w-24"
                onClick={handleApprove}
              >
                Approve
              </Button>
              <Button
                type="primary"
                style={{ background: "#DC2626", borderRadius: "10px" }}
                className="text-sm py-5 px-6 w-24"
                onClick={handleReject}
              >
                Reject
              </Button>
            </>
          )}
        </div>
        {showPopup && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
            <PopupCard
              type={popupData.type}
              title={popupData.title}
              message={popupData.message}
            />
          </div>
        )}
      </div>
    </DailogBox>
  );
};

export default ProjectSetUp;